import module from 'finanzas/module.js'

function FinanzasEmpresasfacturadoService ($api, $export, $http) {
  this.get = function (start, end, ids_empresas) {
    return $http.get('kendu/finanzas/empresasfacturado', {
        params: {
          start: start.toYMD(),
          end: end.toYMD(),
          ids_empresas: ids_empresas,
        },
      })
      .then((data) => {
        var cabeceras = encabezados(angular.copy(start), end)
        return formarDetalles(data.data, cabeceras)
      })

  }

  function encabezados (d1, d2) {
    let meses = monthDiff(d1, d2)
    let mesesanio = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiempre', 'Octubre', 'Noviembre', 'Diciciembre']
    let encabezadoMeses = []
    let encabezado = ''

    for (let i = 0; i < meses; i++) {
      encabezado = mesesanio[d1.getMonth()] + '_' + d1.getFullYear()
      encabezadoMeses.push(encabezado)
      d1.setMonth(d1.getMonth() + 1)
    }

    return encabezadoMeses
  }

  function formarDetalles (data, encabezados) {
    var detalles = [],
      propiedades
    data.forEach(function (item) {
      encabezados.forEach(function (elemento) {
        propiedades = elemento.split('_')
        detalles.push({
          mes: propiedades[0],
          anio: propiedades[1],
          valor: item[elemento],
        })
      })
      item.DejoDeTrabajar = parseFloat(detalles[detalles.length - 1].valor) > 0
      item.Facturacion = detalles
      detalles = []
    })
    return data.map(function (item) {
      return {
        DejoDeTrabajar: item.DejoDeTrabajar,
        Facturacion: item.Facturacion,
        Descripcion: item.Descripcion,
        Num_Operaciones: item.Num_Operaciones,
      }
    })
  }

  function monthDiff (d1, d2) {
    var months
    months = (d2.getFullYear() - d1.getFullYear()) * 12
    months -= d1.getMonth() + 1
    months += d2.getMonth()
    return months <= 0 ? 0 : months + 2
  }

  this.exportarXLS = function (data, archivo) {
    var pages = [],
      aux = [],
      datos = [],
      encabezados = []

    data.map(function (item) {
      aux = [
        item.Descripcion,
        item.Num_Operaciones,
      ]

      item.Facturacion.forEach((elemento) => (aux.push(elemento.valor)))

      datos.push(aux)
    })
    encabezados = [
      {
        label: 'Empresa',
        format: {
          align: 'left',
          width: 40,
        },
      }, {
        label: 'Número de Op.',
        format: {
          align: 'right',
          width: 20,
        },
      },
    ]
    data[0].Facturacion.map(function (elemento) {
      encabezados.push({
        label: elemento.mes + ' ' + elemento.anio,
        format: {
          type: 'currency',
          align: 'right',
          width: 12,
        },
      })
    })

    pages.push(new Page(datos, encabezados, 'Facturado'))
    aux = []
    datos = []
    encabezados = []

    $export.excel(archivo, pages)
  }

  function Page (data, encabezados, nombre) {
    // columanas = generarColumnas
    return {
      name: nombre,
      columns: encabezados,
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'A8',
      },
      data: data,
    }
  }
}

module.service('FinanzasEmpresasfacturado', FinanzasEmpresasfacturadoService)




// WEBPACK FOOTER //
// ./src/finanzas/_/empresasfacturado/services/FinanzasEmpresasfacturado.js